/**
 * Rückfrage, bevor ein Erfassungsfenster durch einen Klick außerhalb (auf den Hintergrund) geschlossen
 * wird. Verhindert, dass versehentliches Danebenklicken alle Eingaben verwirft. Der Abbrechen-Knopf
 * schließt weiterhin ohne Rückfrage.
 *
 * Rückgabe: true = schließen erlaubt (Nutzer hat bestätigt), false = offen lassen.
 */
export function confirmDiscard(
  message = 'Eingaben verwerfen? Nicht gespeicherte Änderungen gehen verloren.',
): boolean {
  if (typeof window === 'undefined' || typeof window.confirm !== 'function') return true;
  return window.confirm(message);
}
